import { ENV } from '@core/constants/env';
import {
    browserTracingIntegration,
    init,
    replayIntegration,
} from '@sentry/react';

export const excludeErrors = [
    'fbq is not defined',
    '_mfq is not defined',
    "Can't find variable: fbq",
    "Can't find variable: _mfq",
    "Can't find variable: _mfq",
    "Can't find variable: gmo",
    'mouseflow is not defined',
    "Cannot read properties of undefined (reading 'domInteractive')",
    "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document.",
    'error_send_reset_password_link: cooldown',
    'duplicate_submit_application',
    'duplicate_submit_lead_application',
    'Failed to fetch',
    'this.shouldEnforce is not a function',
    "this.shouldEnforce is not a function. (In 'this.shouldEnforce()', 'this.shouldEnforce' is undefined)",
    'pv_submit_phone_cooldown',
    'pv_submit_phone_invalid_phone',
    "Cannot read properties of undefined (reading 'length')",
    "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
    'The object can not be found here.',
    "undefined is not an object (evaluating '_10",
    "Cannot read properties of undefined (reading 'focus')",
    "undefined is not an object (evaluating 'e.",
];

const sampleErrors = [{ message: 'JWTExpired', percentage: 0.25 }];

export default function initializeSentry() {
    init({
        environment: ENV.MODE,
        // Comment out line below when troubleshooting in local development
        enabled: ENV.MODE !== 'development',
        dsn: 'https://766e91d94e444b788d561667b312f4fa@o433895.ingest.us.sentry.io/6075298',
        integrations: [
            browserTracingIntegration(),
            replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
                maxReplayDuration: 10 * 60 * 1000, // 10 minutes
                networkDetailAllowUrls: [
                    'https://hasura.bcf-ng-dev.us-east-1.spotloan.com/v1/graphql',
                    'https://hasura.bcf-ng-qa.us-east-1.spotloan.com/v1/graphql',
                    'https://graphql.spotloan.com/v1/graphql',
                ],
                networkRequestHeaders: [
                    'Authorization',
                    'x-bcf-ipa',
                    'x-bcf-nuggets',
                    'Cookie',
                ],
                networkResponseHeaders: ['Set-Cookie'],
            }),
        ],

        // Performance Monitoring
        tracesSampleRate: 0.05, //  Capture 5% of the transactions for performance
        // Session Replay
        replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        beforeSend(event) {
            if (
                event.exception &&
                event.exception.values &&
                event.exception.values.length > 0
            ) {
                const exceptionValue = event.exception?.values[0].value;
                if (
                    typeof exceptionValue === 'string' &&
                    excludeErrors.includes(exceptionValue)
                ) {
                    return null;
                }
                for (const sampleError of sampleErrors) {
                    if (
                        typeof exceptionValue === 'string' &&
                        exceptionValue.includes(sampleError.message) &&
                        sampleError.percentage
                    ) {
                        if (Math.random() > sampleError.percentage) {
                            return null;
                        }

                        break;
                    }
                }
            }

            return event;
        },
    });
}
